import axios from "axios";
import { errorMessage, tokenExpired, errorAlert } from "@/api/errorMessages";
import * as api from "@/api/oauth";
import allocate from "./modules/allocate";
import userConfig from "./modules/userConfig";
import autoassigner from "./modules/autoassigner";
import rolData from "./modules/rolData";
import department from "./modules/department";
import io from "socket.io-client";

export default {
  namespaced: true,
  state: {
    users: null,
    userStatus: null,
    newUser: 0,
    availableUsers: null,
    dataUsersSocket: null,
    infoUsers: null
  },
  getters: {
    showUsers(state) {
      return state.users;
    },
    showAvailableUsers(state) {
      return state.availableUsers;
    },
    showDataUsersSocketListener(state) {
      return state.infoUsers;
    }
  },
  mutations: {
    setUsers(state, newUsers) {
      state.users = newUsers;
    },
    pushUser(state, newUser) {
      state.users.push(newUser);
    },
    setUserStatus(state, newStatus) {
      state.userStatus = newStatus;
    },
    newUser(state) {
      state.newUser += 1;
    },
    setAvailableUsers(state, newStatus) {
      state.availableUsers = newStatus;
    },
    setDataUsersSocketListener(state) {
      state.dataUsersSocket.on("quotes-per-users-report", function(data) {
        state.infoUsers = data;
      });
    },
    closeDataUsersSocketListener(state) {
      state.dataUsersSocket.disconnect();
    }
  },
  actions: {
    async getUsers({ commit }, info) {
      try {
        let response;
        if (info.activeName === "first") {
          response = await axios.get(
            process.env.VUE_APP_BACK_ROUTE +
              `/api/user/quote-resume/${info.departmentId}/`,
            api.getToken()
          );
        } else {
          response = await axios.get(
            process.env.VUE_APP_BACK_ROUTE +
              `/api/user-admin/department/${info.departmentId}/role/${info.rolId}`,
            api.getToken()
          );
        }
        if (response.status == 200) {
          commit("setUsers", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },

    async getAvailableUsers({ commit }, departmentId) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/user/${departmentId}/not-busy/`,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setAvailableUsers", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },

    async addUser(__, info) {
      const payload = { ...info };
      delete payload.confirmPassword;
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/user/`,
          payload,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 201) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async updateUser(__, info) {
      const payload = { ...info.payload };
      delete payload.confirmPassword;
      delete payload.password;
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE + `/api/user/${info.userId}/`,
          payload,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 201) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async deleteUser(__, userId) {
      try {
        let response = await axios.delete(
          process.env.VUE_APP_BACK_ROUTE + `/api/user/${userId}/`,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async getAllUsers(__, username) {
      const params = {};
      params.skip = 0;
      params.limit = 99999;
      if (username) {
        params.username = username;
      } else {
        delete params.username;
      }
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/user/all/`,
          {
            params: params,
            ...api.getToken()
          }
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async getUserById(__, userId) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/user/get-by-id/${userId}/`,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async getUserRoleAndDepartment(__, userId) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/user/get-rol-department/${userId}`,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async addUserDepartmentAndRole(__, data) {
      const body = { ...data };
      body.is_busy = false;
      body.is_active = true;
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/user/rol-department`,
          body,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async deleteUserDepartmentAndRole(__, data) {
      try {
        let response = await axios.delete(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/user/${data.departmentId}/${data.userId}/${data.rolId}`,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async getMessage(_, info) {
      let params = {};
      params.shp = info.shp;
      params.subject = info.subject;
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/message/search-global/`,
          {
            params,
            ...api.getToken()
          }
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          errorMessage();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
      }
    },
    // USER-ADMIN MODULE
    async createUser(__, info) {
      const payload = { ...info };
      delete payload.confirmPassword;
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/user-admin/`,
          payload,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 201) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async editUser(__, info) {
      const payload = { ...info.payload };
      delete payload.confirmPassword;
      delete payload.password;
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/user-admin/${info.userId}/${payload.department_[0]}/${payload.rol_[0]}/`,
          payload,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 201) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    // WEBSOCKET USER DATA
    dataUsersSocket({ commit, state }) {
      let token = localStorage.getItem("charlie-otr-token");
      const baseDomain = process.env.VUE_APP_BACK_ROUTE;
      const dataGetUsersRoute = baseDomain + "/" + "admin";
      state.dataUsersSocket = io(dataGetUsersRoute, {
        path: "/sio/socket.io/",
        transports: ["websocket"],
        query: {
          Authorization: `Bearer ${token}`
        }
      });
      commit("setDataUsersSocketListener");
    }
  },
  modules: {
    allocate,
    userConfig,
    autoassigner,
    rolData,
    department
  }
};
